import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { ActivatedRoute } from '@angular/router';
import { TaskService } from 'src/app/services/task.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';

declare var $: any;
import * as _ from 'lodash';
import { NcdclientService } from 'src/app/services/NCD/ncdclient.service';
import { AlertComponent } from '../../alert/alert.component';
import { LoaderService } from 'src/app/services/loader.service';
@Component({
  selector: 'app-create-issue',
  templateUrl: './create-issue.component.html',
  styleUrls: ['./create-issue.component.css']
})
export class CreateIssueComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  error: any = { isError: false, errorMessage: '' };

  restrictTabflag: boolean = true;
  isPartATabFilled: boolean = false;
  editIssueId: any;
  partAForm: FormGroup;
  partBForm: FormGroup;
  partCForm: FormGroup;
  public issueOpeningDateModel: any;
  public firstCouponPaymentDateModel: any;
  public redemptionDateModel: any;
  public issueClosingDateModel: any;
  public payInDateModel: any;
  public redemptionDate: any;

  isIssueSeriesUnique: boolean = false;
  isIssueSeriesValid: boolean = false;
  libraryPartAFieldsArray: any = [];
  partAFieldsArray: any = [];
  partBFieldsArray: any = [];
  editPartAFieldsArray: any = [];
  libraryPartBFieldsArray: any = [];
  multiOptionFieldsArray: any = [];
  libraryPartAandBFieldsArray: any = [];
  partAFieldsValueList: any = [];
  partBFieldsValueList: any = [];
  partADropdownList: any = [];
  partBDropdownList: any = [];
  partBMultiSelectDropDownList: any = [];
  partAMultiSelectDropDownList: any = [];
  partAResponseIssueId: any;
  addBtn = true;
  issueCreated: boolean = false;
  userId: any;
  issueStatus: any;
  status: boolean = false;
  issueDetails: any = [];
  enableTermSheet: boolean = false;
  financialYears: any = [];
  editTermsheetButton: boolean = false;
  updateButtonDisable: boolean = false;
  userList: any = [];

  TodayDate: NgbDateStruct;
  currentYear: any;
  selectedCheckersList: any = [];
  selectedRatingValueList: any = [];
  checkersList: any;
  premiumDiscountSelected: boolean = false;
  noneSelected: boolean = false;
  premiumSelectedValue: any;
  discountSelectedValue: any;
  isPerpetual: boolean = false;
  disabledOnclick: boolean;
  makerName: any;

  dynamicValidationArray: any = [];

  couponTypeList = ['Fixed', 'Variable', 'Zero'];

  redemptionTypeList = ['None', 'Premium', 'Discount'];

  interestPaymentFrequencyList = ['Monthly', 'Quarterly', 'Half Yearly', 'Annual', 'On Maturity', 'Compounded Monthly and payable On Maturity', 'Compounded Quarterly and payable On Maturity', 'Compounded Half Yearly and payable On Maturity', 'Compounded Annual and payable On Maturity'];

  redemptionDateFields = ['Redemption', 'Perpetual'];

  constructor(private ncdClientService: NcdclientService,
    private formBuilder: FormBuilder,
    private alert: AlertComponent,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private taskService: TaskService,
    private location: Location) { }

    ngOnDestroy(): void {
      // Re-enable loader when navigating away from this component
      this.loaderService.enable();
    }

  ngOnInit() {
    this.loaderService.disable();
    this.issueDetails = [];
    this.userId = JSON.parse(localStorage.getItem('user')).FirstName + " " + JSON.parse(localStorage.getItem('user')).LastName

    this.activatedRoute.params.subscribe(params => {
      // console.log(JSON.parse(params['issueId']))
      if (params['issueId'] != undefined) {
        this.addBtn = false;
        this.restrictTabflag = false;
        this.editIssueId = JSON.parse(params['issueId']);
        this.getIssueDetailsById(this.editIssueId);
      } else {
        this.restrictTabflag = true;
        this.addBtn = true;
        this.getPartATermsheetData();
        this.getPartBTermsheetData();
      }
    })

    this.getCheckersList();

    this.environmentSettings = environment;

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });


    this.partAForm = this.formBuilder.group({
      issueSeries: ['', [Validators.required]],
      financialYear: ['', [Validators.required]],
      minApplication: ['', [Validators.required]],
      minApplicationDropdown: ['', [Validators.required]],
      multiples: ['', [Validators.required]],
      multiplesDropdown: ['', [Validators.required]],
      issueSize: ['', [Validators.required]],
      optionToRetainOversubscription: ['', [Validators.required]],
      issueOpeningDate: ['', [Validators.required]],
      issueClosingDate: ['', [Validators.required]],
      calculatedRecordDate: ['', [Validators.required]],
      isCashflowHolidayPreponed: ['No', [Validators.required]],
      partAField: new FormArray([]),
      multiOptionFields: this.formBuilder.array([this.addDynamicMultiOptionFieldsFormGroup()])
    });

    this.partBForm = this.formBuilder.group({
      partBField: new FormArray([])
    });

    this.partCForm = new FormGroup({
      maker: new FormControl('', []),
      checker: new FormControl('', []),
      authoriser: new FormControl('', []),
    });

    // Financial year
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear() - 10;
    this.TodayDate = { year: year, month: month, day: day };

    this.currentYear = year;

    for (let i = 0; i <= 20; i++) {
      var years = this.currentYear + i;
      var financialYears = years + "-" + (years + 1);
      this.financialYears.push(financialYears);

      if (i == 10) {
        this.partAForm.controls.financialYear.setValue(financialYears, { onlySelf: true })
      }
    }
  }
  back() {

    this.location.back(); // Navigate back to the previous page
  }
  // ==========================================================COMMON FUNTIONS========================================================

  addDynamicMultiOptionFieldsFormGroup(): FormGroup {
    return this.formBuilder.group({
      couponRate: ['', [Validators.required]],
      payInDate: ['', Validators.required],
      firstCouponPaymentDate: ['', Validators.required],
      redemptionAmountType: ['', Validators.required],
      isPerpetual: ['', Validators.required],
      redemptionDate: ['', Validators.required],
      premiumDiscount: ['',],
      couponType: ['', Validators.required],
      interestPaymentFrequency: ['', Validators.required],
      faceValue: ['', Validators.required]
    });
  }


  addNewMultiOptionBlock() {
    (<FormArray>this.partAForm.get('multiOptionFields')).push(this.addDynamicMultiOptionFieldsFormGroup())
  }

  removeMultiOptionBlock(index) {
    var formArray = <FormArray>this.partAForm.controls.multiOptionFields;
    formArray.removeAt(index)
  }



  initialisePartAFieldsArray(): FormGroup {
    const group = new FormGroup({
    })
    return group;
  }

  initialisePartBFieldsArray(): FormGroup {
    const group = new FormGroup({
    })
    return group;
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }


  onlyTwoDecimal(ev) {
    $('.dacimalFix').on('input', function () {
      this.value = this.value.replace(/(\.[\d]{4})./g, '$1'); // not more than 4 digits after decimal
    });
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  onlyNumberWithoutZero(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 48 && keyCode < 58) || (keyCode > 96 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }


  onlyAlphabates(ev) {
    var charCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if (!(charCode >= 65 && charCode <= 120) && (charCode != 32 && charCode != 0) && (charCode != 8) && (charCode != 46) && (charCode != 9)
      && (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
      event.preventDefault();
    }
  }

  commaSeperatedToNumberOnly(value) {
    if (value == "" || value == null || value == undefined) {
      return "";
    }
    else {
      value = value.toString();
      return value.replace(new RegExp(",".replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), "");
    }
  }

  selectRedemptionPremiumDiscountChange(ev, i) {
    if (ev.target.value == "Premium" || ev.target.value == "Discount") {
      this.partAForm.controls.multiOptionFields['controls'][i].controls.premiumDiscount.setValue('');
      $("#premiumDiscount" + i).prop("disabled", false);
    } else {
      this.partAForm.controls.multiOptionFields['controls'][i].controls.premiumDiscount.setValue(0);
      $("#premiumDiscount" + i).prop("disabled", true);
    }
  }

  selectChangeDate(ev, i) {
    var formArray: FormArray = <FormArray>this.partAForm.controls.multiOptionFields;
    var formGroup: FormGroup = <FormGroup>formArray.controls[i];
    if (ev.target.value == "Redemption") {
      $("#redemptionDate" + i).prop("disabled", false);
      $("#redemption" + i).prop("disabled", false);
      if (formGroup.value.redemptionDate != null && formGroup.value.redemptionDate != '' && formGroup.value.redemptionDate == "31-12-2099") {
        var date = formGroup.value.redemptionDate
        var redemptionDate = date.day + "-" + date.month + "-" + date.year;
        formGroup.controls.redemptionDate.setValue(redemptionDate);
      } else {
        formGroup.controls.redemptionDate.setValue(null);
      }
    } else {
      $("#redemptionDate" + i).prop("disabled", true);
      $("#redemption" + i).prop("disabled", true);
      let dt = { year: 2099, month: 12, day: 31 }
      formGroup.controls.redemptionDate.setValue(dt)
    }
  }

  clearIssueOpeningDateErrorMessage() {
    $("#issueOpeningDateValid").text("").show();
  }

  checkIssueOpeningDateForRedemptionDate(ev, i) {
    if (this.issueOpeningDateModel != null && this.issueOpeningDateModel != '') {
      if (this.issueOpeningDateModel != null && this.issueOpeningDateModel != '' && ev != null && ev != '') {
        this.updateButtonDisable = false;
        $("#issueOpeningDateValid").text("").show();
        var d1 = this.setDate(this.issueOpeningDateModel)
        var d2 = this.setDate(ev)
        if (new Date(d1).getTime() > new Date(d2).getTime()) {
          this.updateButtonDisable = true;
          $("#redemptionDateValid" + i).text("Redemption Date should be greater than Issue Opening Date.").show();
          return false;
        }
        else {
          this.updateButtonDisable = false;
          $("#redemptionDateValid" + i).text("").show();
        }
      }
    } else {
      this.updateButtonDisable = true;
      $("#issueOpeningDateValid").text("Please Select Issue Opening Date.").show();
    }

    if (ev != null) {
      this.partAForm.controls.multiOptionFields.value[i].redemptionDate = ev;
      if (ev != null && ev != '' && this.partAForm.controls.multiOptionFields.value[i].firstCouponPaymentDate != null && this.partAForm.controls.multiOptionFields.value[i].firstCouponPaymentDate != '') {
        let d3 = this.setDate(this.partAForm.controls.multiOptionFields.value[i].firstCouponPaymentDate);
        let d4 = this.setDate(ev);
        if ((this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == '' && $("#isInterestPayFreqCompounded" + i).text() == '' && $("#isInterestPayFreqOnMaturity" + i).text() == '') || this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency != 'On Maturity') {
          if (new Date(d3).getTime() >= new Date(d4).getTime()) {
            this.updateButtonDisable = true;
            $("#firstCouponDateValid" + i).text("First Coupon Payment Date should be less than Redemption Date.").show();
            return false;
          }
          else {
            this.updateButtonDisable = false;
            $("#firstCouponDateValid" + i).text("").show();
          }
        } else if (this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == 'On Maturity') {
          if (new Date(d3).getTime() != new Date(d4).getTime()) {
            this.updateButtonDisable = true;
            $("#isInterestPayFreqCompounded" + i).text("").show();
            $("#firstCouponDateValid" + i).text("First Coupon Payment Date should be equal to Redemption Date if On Maturity is selected.").show();
            return false;
          }
          else {
            this.updateButtonDisable = false;
            $("#firstCouponDateValid" + i).text("").show();
          }
        }
      }
    }
  }

  checkFirstCouponDateGreaterThanPayinDate(ev, i, dateName) {
    if (dateName == 'payIn') {
      this.partAForm.controls.multiOptionFields.value[i].payInDate = ev;
    } else if (dateName == 'firstCoupon') {
      this.partAForm.controls.multiOptionFields.value[i].firstCouponPaymentDate = ev;
    }

    // $("#payinDateValid" + i).text("").show();
    // $("#firstCouponDateValid" + i).text("").show();

    if (this.partAForm.controls.multiOptionFields.value[i].payInDate != null && this.partAForm.controls.multiOptionFields.value[i].payInDate != '' && this.partAForm.controls.multiOptionFields.value[i].firstCouponPaymentDate != null && this.partAForm.controls.multiOptionFields.value[i].firstCouponPaymentDate != '') {
      let d1 = this.setDate(this.partAForm.controls.multiOptionFields.value[i].firstCouponPaymentDate);
      let d2 = this.setDate(this.partAForm.controls.multiOptionFields.value[i].payInDate);
      if ((this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == '' && $("#isInterestPayFreqCompounded" + i).text() == '' && $("#isInterestPayFreqOnMaturity" + i).text() == '') || this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == 'Monthly' || this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == 'Quarterly' || this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == 'Half Yearly' || this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == 'Annual') {
        if (new Date(d1).getTime() <= new Date(d2).getTime()) {
          this.updateButtonDisable = true;
          $("#payinDateValid" + i).text("Pay-In Date should be less than First Coupon Payment Date.").show();
          return false;
        }
        else {
          this.updateButtonDisable = false;
          $("#payinDateValid" + i).text("").show();
        }
      } else if (this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == 'Compounded Monthly and payable On Maturity' || this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == 'Compounded Quarterly and payable On Maturity' || this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == 'Compounded Half Yearly and payable On Maturity' || this.partAForm.controls.multiOptionFields.value[i].interestPaymentFrequency == 'Compounded Annual and payable On Maturity') {
        if (new Date(d1).getTime() != new Date(d2).getTime()) {
          this.updateButtonDisable = true;
          $("#isInterestPayFreqCompounded" + i).text("").show();
          $("#firstCouponDateValid" + i).text("First Coupon Payment Date should be equal to Pay-In Date if compounded options are selected.").show();
          return false;
        }
        else {
          this.updateButtonDisable = false;
          $("#firstCouponDateValid" + i).text("").show();
        }
      }
    }

    if (this.partAForm.controls.multiOptionFields.value[i].redemptionDate != null && this.partAForm.controls.multiOptionFields.value[i].redemptionDate != '' && this.partAForm.controls.multiOptionFields.value[i].firstCouponPaymentDate != null && this.partAForm.controls.multiOptionFields.value[i].firstCouponPaymentDate != '') {
      let d3 = this.setDate(this.partAForm.controls.multiOptionFields.value[i].firstCouponPaymentDate);
      let d4 = this.setDate(this.partAForm.controls.multiOptionFields.value[i].redemptionDate);
      if (new Date(d3).getTime() >= new Date(d4).getTime()) {
        this.updateButtonDisable = true;
        $("#firstCouponDateValid" + i).text("First Coupon Payment Date should be less than Redemption Date.").show();
        return false;
      }
      else {
        this.updateButtonDisable = false;
        $("#firstCouponDateValid" + i).text("").show();
      }
    }
  }


  dateValidationBasedOnInterestPaymentFrequencyChange(ev, index) {
    this.updateButtonDisable = false;
    var firstCouponPaymentDate = this.setDate(this.partAForm.controls.multiOptionFields.value[index].firstCouponPaymentDate);
    var redemptionDate = this.setDate(this.partAForm.controls.multiOptionFields.value[index].redemptionDate);
    var payInDate = this.setDate(this.partAForm.controls.multiOptionFields.value[index].payInDate);
    $("#isInterestPayFreqCompounded" + index).text("").show();
    $("#isInterestPayFreqOnMaturity" + index).text("").show();

    if (ev.target.value == 'On Maturity') {
      if (firstCouponPaymentDate != "" && firstCouponPaymentDate != null && redemptionDate != '' && redemptionDate != null) {
        if (new Date(firstCouponPaymentDate).getTime() != new Date(redemptionDate).getTime()) {
          this.updateButtonDisable = true;
          $("#isInterestPayFreqOnMaturity" + index).text("First coupon date and Redemption date should be same to select On Maturity option").show();
          this.partAForm.controls.multiOptionFields['controls'][index].controls.interestPaymentFrequency.setValue('');
        } else if (new Date(payInDate).getTime() >= new Date(firstCouponPaymentDate).getTime()) {
          this.updateButtonDisable = true;
          $("#payinDateValid" + index).text("Pay-In Date should be less than First Coupon Payment Date.").show();
          return false;
        } else {
          this.updateButtonDisable = false;
          $("#payinDateValid" + index).text("").show();
          $("#firstCouponDateValid" + index).text("").show();
          $("#isInterestPayFreqOnMaturity" + index).text("").show();
          this.partAForm.controls.multiOptionFields['controls'][index].controls.interestPaymentFrequency.setValue(ev.target.value);
        }
      }
      // else {
      //   $("#isInterestPayFreqOnMaturity" + index).text("Please Select all the dates first").show();
      //   this.partAForm.controls.multiOptionFields['controls'][index].controls.interestPaymentFrequency.setValue('');
      // }
    } else if (ev.target.value == 'Compounded Monthly and payable On Maturity' || ev.target.value == 'Compounded Quarterly and payable On Maturity' || ev.target.value == 'Compounded Half Yearly and payable On Maturity' || ev.target.value == 'Compounded Annual and payable On Maturity') {
      this.updateButtonDisable = false;
      $("#isInterestPayFreqOnMaturity" + index).text("").show();



      if (firstCouponPaymentDate != "" && firstCouponPaymentDate != null && payInDate != '' && payInDate != null) {
        if (new Date(firstCouponPaymentDate).getTime() != new Date(payInDate).getTime()) {
          this.updateButtonDisable = true;
          $("#isInterestPayFreqCompounded" + index).text("First coupon date and Pay-In date should be same to select this option").show();
          this.partAForm.controls.multiOptionFields['controls'][index].controls.interestPaymentFrequency.setValue('');
        } else {
          this.updateButtonDisable = false;
          $("#payinDateValid" + index).text("").show();
          $("#isInterestPayFreqCompounded" + index).text("").show();
          this.partAForm.controls.multiOptionFields['controls'][index].controls.interestPaymentFrequency.setValue(ev.target.value);
        }
      }
      if (firstCouponPaymentDate != "" && firstCouponPaymentDate != null && redemptionDate != '' && redemptionDate != null) {
        if (new Date(firstCouponPaymentDate).getTime() >= new Date(redemptionDate).getTime()) {
          this.updateButtonDisable = true;
          $("#firstCouponDateValid" + index).text("First Coupon Payment Date should be less than Redemption Date.").show();
          return false;
        } else {
          this.updateButtonDisable = false;
          $("#payinDateValid" + index).text("").show();
          $("#firstCouponDateValid" + index).text("").show();
        }
      }
    } else {
      this.updateButtonDisable = false;
      $("#isInterestPayFreqCompounded" + index).text("").show();
      if (payInDate != null && payInDate != '' && payInDate != undefined) {
        this.checkFirstCouponDateGreaterThanPayinDate(this.partAForm.controls.multiOptionFields.value[index].payInDate, index, 'payIn');
      }
      if (firstCouponPaymentDate != null && firstCouponPaymentDate != '' && firstCouponPaymentDate != undefined) {
        this.checkFirstCouponDateGreaterThanPayinDate(this.partAForm.controls.multiOptionFields.value[index].firstCouponPaymentDate, index, 'firstCoupon');
      }
      if (redemptionDate != null && redemptionDate != '' && redemptionDate != undefined) {
        this.checkIssueOpeningDateForRedemptionDate(this.partAForm.controls.multiOptionFields.value[index].redemptionDate, index);
      }
    }
  }

  onBlurCheckIssueSeries() {
    var issueSeries = this.partAForm.controls.issueSeries.value;
    if (issueSeries == '') {
      this.isIssueSeriesValid = true;
      this.isIssueSeriesUnique = false;
    } else {
      this.isIssueSeriesValid = false;
      var issueId = null;
      if (_.size(this.issueDetails) > 0) {
        issueId = this.issueDetails._id;
      }
      var searchObject = {
        IssueSeries: issueSeries,
        issueId: issueId
      }
      this.ncdClientService.getUniqueIssueSeries(searchObject)
        .subscribe((issueSeriesValue: any) => {
          if (issueSeriesValue.message == 'Issue series already exists') {
            this.isIssueSeriesUnique = true;
          } else {
            this.isIssueSeriesUnique = false;
          }
        });
    }
  }

  onBlurCheckIssueSize() {
    var issueSize = this.partAForm.controls.issueSize.value.replace(/\,/g, "");
    if (issueSize != "" && !isNaN(issueSize)) {
      this.partAForm.controls.issueSize.setValue(this.partAForm.controls.issueSize.value + " Crs");
    }
  }

  onBlurCheckRetainOversubscription() {
    var optionToRetainOversubscription = this.partAForm.controls.optionToRetainOversubscription.value.replace(/\,/g, "");
    if (optionToRetainOversubscription != "" && !isNaN(optionToRetainOversubscription)) {
      this.partAForm.controls.optionToRetainOversubscription.setValue(this.partAForm.controls.optionToRetainOversubscription.value + " Crs");
    }
  }

  onBlurCheckCouponRate(i) {
    var couponRate = this.partAForm.controls.multiOptionFields.value[i].couponRate.replace(/\,/g, "");
    if (couponRate != "" && !isNaN(couponRate)) {
      this.partAForm.controls.multiOptionFields['controls'][i].controls.couponRate.setValue(this.partAForm.controls.multiOptionFields.value[i].couponRate + " %");
    }
  }

  checkIssueSeriesBeforeSave(status) {
    this.disabledOnclick = true;
    var issueSeries = this.partAForm.controls.issueSeries.value;
    if (issueSeries == '') {
      this.isIssueSeriesValid = true;
      this.isIssueSeriesUnique = false;
    } else {
      this.isIssueSeriesValid = false;
      this.saveIssue(status);
    }
  }

  getSelectedCheckers(item: any) {
    this.selectedCheckersList.push(item.value);
  }

  multipleCheckersDeselected(item: any) {
    let indexOfItem = this.selectedCheckersList.findIndex(o => o == item.value);
    this.selectedCheckersList.splice(indexOfItem, 1);
  }

  // MultiSelect Rating Field
  getSelectedValue(item: any) {
    this.selectedRatingValueList.push(item.value);
  }

  multipleDeselectedValue(item: any) {
    let indexOfItem = this.selectedRatingValueList.findIndex(o => o == item.value);
    this.selectedRatingValueList.splice(indexOfItem, 1);
  }

  // =======================================================UPDATE====================================================================
  getIssueDetailsById(editIssueId) {
    // console.log(editIssueId['issueId'])

    this.libraryPartAandBFieldsArray = [];
    this.ncdClientService.getIssueDetailsById(editIssueId).subscribe(issueDetailsById => {
      // console.log(issueDetailsById)
      this.editTermsheetButton = true;

      var issueDetailsByIdArray = issueDetailsById.data[0];

      this.issueStatus = issueDetailsByIdArray.IssueCreatedStatus;
      this.issueDetails = issueDetailsByIdArray;

      var issueOpeningDate;
      var issueClosingDate;

      if (issueDetailsByIdArray.IssueOpeningDate == null || issueDetailsByIdArray.IssueOpeningDate == '' || issueDetailsByIdArray.IssueOpeningDate == undefined) {
        issueOpeningDate = null;
      } else {
        issueOpeningDate = { year: new Date(issueDetailsByIdArray.IssueOpeningDate).getFullYear(), month: new Date(issueDetailsByIdArray.IssueOpeningDate).getMonth() + 1, day: new Date(issueDetailsByIdArray.IssueOpeningDate).getDate() };
      }

      if (issueDetailsByIdArray.IssueClosingDate == null || issueDetailsByIdArray.IssueClosingDate == '' || issueDetailsByIdArray.IssueClosingDate == undefined) {
        issueClosingDate = null;
      } else {
        issueClosingDate = { year: new Date(issueDetailsByIdArray.IssueClosingDate).getFullYear(), month: new Date(issueDetailsByIdArray.IssueClosingDate).getMonth() + 1, day: new Date(issueDetailsByIdArray.IssueClosingDate).getDate() };
      }


      this.partAForm.controls.issueSeries.setValue(issueDetailsByIdArray.IssueSeries);
      this.partAForm.controls.financialYear.setValue(issueDetailsByIdArray.FinancialYear);
      this.partAForm.controls.minApplication.setValue(issueDetailsByIdArray.MinApplication);
      this.partAForm.controls.minApplicationDropdown.setValue(issueDetailsByIdArray.MinApplicationDropdown);
      this.partAForm.controls.multiples.setValue(issueDetailsByIdArray.Multiples);
      this.partAForm.controls.multiplesDropdown.setValue(issueDetailsByIdArray.MultiplesDropdown);
      this.partAForm.controls.issueSize.setValue(issueDetailsByIdArray.IssueSize);
      this.partAForm.controls.optionToRetainOversubscription.setValue(issueDetailsByIdArray.OptionToRetainOversubscription);
      this.partAForm.controls.calculatedRecordDate.setValue(issueDetailsByIdArray.calculatedRecordDate);
      this.partAForm.controls.isCashflowHolidayPreponed.setValue(issueDetailsByIdArray.isCashflowHolidayPreponed);
      this.issueOpeningDateModel = issueOpeningDate;
      this.issueClosingDateModel = issueClosingDate;

      // PART A
      // removing controls
      const formArray: FormArray = <FormArray>this.partAForm.get('partAField');
      while (formArray.length !== 0) {
        formArray.removeAt(0)
      }
      this.libraryPartAFieldsArray = [];
      this.libraryPartAFieldsArray = issueDetailsByIdArray.PartA;
      var self = this;
      if (this.libraryPartAFieldsArray.length > 0) {
        var count = 0;

        _.forEach(this.libraryPartAFieldsArray, function (partAFieldList) {
          self.partADropdownList[count] = [];
          self.partAMultiSelectDropDownList[count] = [];
          const formArray: FormArray = <FormArray>self.partAForm.get('partAField');
          formArray.push(self.initialisePartAFieldsArray());
          var formGroup: FormGroup = <FormGroup>formArray.controls[count];

          self.partAFieldsValueList = partAFieldList.ListOfFieldsValue;
          if (self.partAFieldsValueList.length > 0) {
            for (let i = 0; i < self.partAFieldsValueList.length; i++) {
              var valueList = self.partAFieldsValueList[i]['newFieldValue' + i]
              self.partADropdownList[count].push(valueList);
            }
          }

          // MultiSelect Dropdown
          if (partAFieldList.InputType == "MultiSelectDropDown") {
            self.partAMultiSelectDropDownList[count] = self.partADropdownList[count].map(function (element) {
              return {
                'label': element,
                'value': element
              }
            });
          }

          formGroup.addControl("fieldName" + count, new FormControl(partAFieldList.FieldName, []));
          formGroup.addControl("defaultValue" + count, new FormControl(partAFieldList.DefaultValue, [Validators.required]));
          formGroup.addControl("inputType" + count, new FormControl(partAFieldList.InputType, []));
          formGroup.addControl("listOfFieldsValue" + count, new FormControl(partAFieldList.ListOfFieldsValue, []));

          formGroup.controls["fieldName" + count].updateValueAndValidity();
          formGroup.controls["defaultValue" + count].updateValueAndValidity();

          count++;
        })
      }

      // PART B
      // removing controls
      const formArrayPartB: FormArray = <FormArray>this.partBForm.get('partBField');
      while (formArrayPartB.length !== 0) {
        formArrayPartB.removeAt(0)
      }

      this.libraryPartBFieldsArray = [];
      this.libraryPartBFieldsArray = issueDetailsByIdArray.PartB;
      // var self = this;
      if (this.libraryPartBFieldsArray.length > 0) {
        var count = 0;

        _.forEach(this.libraryPartBFieldsArray, function (partBFieldList) {
          self.partBDropdownList[count] = [];
          self.partBMultiSelectDropDownList[count] = [];
          const formArray: FormArray = <FormArray>self.partBForm.get('partBField');
          formArray.push(self.initialisePartBFieldsArray());
          var formGroup: FormGroup = <FormGroup>formArray.controls[count];

          self.partBFieldsValueList = partBFieldList.ListOfFieldsValue;
          if (self.partBFieldsValueList.length > 0) {
            for (let i = 0; i < self.partBFieldsValueList.length; i++) {
              var valueList = self.partBFieldsValueList[i]['newFieldValue' + i]
              self.partBDropdownList[count].push(valueList);
            }
          }

          // MultiSelect Dropdown
          if (partBFieldList.InputType == "MultiSelectDropDown") {
            console.log(self.partBDropdownList[count])
            self.partBMultiSelectDropDownList[count] = self.partBDropdownList[count].map(function (element) {
              console.log(self.partBMultiSelectDropDownList[count])
              return {
                'label': element,
                'value': element
              }
            });
          }
          console.log(self.partBMultiSelectDropDownList)

          formGroup.addControl("fieldName" + count, new FormControl(partBFieldList.FieldName, []));
          formGroup.addControl("defaultValue" + count, new FormControl(partBFieldList.DefaultValue, [Validators.required]));
          formGroup.addControl("inputType" + count, new FormControl(partBFieldList.InputType, []));
          formGroup.addControl("listOfFieldsValue" + count, new FormControl(partBFieldList.ListOfFieldsValue, []));

          formGroup.controls["fieldName" + count].updateValueAndValidity();
          formGroup.controls["defaultValue" + count].updateValueAndValidity();

          count++;
        })
      }

      // Part C
      this.partCForm.controls.maker.setValue(issueDetailsByIdArray.PartC.Maker);
      this.partCForm.controls['checker'].setValue(issueDetailsByIdArray.PartC.Checker);
      this.selectedCheckersList = issueDetailsByIdArray.PartC.Checker;
      this.partCForm.controls.authoriser.setValue(issueDetailsByIdArray.PartC.Authoriser);
      this.makerName = issueDetailsByIdArray.PartC.Maker;

      this.multiOptionCashflowFunction(issueDetailsByIdArray);
    });
  }

  multiOptionCashflowFunction(issueDetailsByIdArray) {
    // Multiple-Options
    var multiOptionDynamicFields = issueDetailsByIdArray.MultiOption;
    var self = this;
    _.forEach(multiOptionDynamicFields, function (element) {
      if (element.payInDate != null && element.payInDate != '' && element.payInDate != undefined) {
        element.payInDate = { year: new Date(element.payInDate).getFullYear(), month: new Date(element.payInDate).getMonth() + 1, day: new Date(element.payInDate).getDate() };
      } else {
        element.payInDate = null;
      }
      if (element.firstCouponPaymentDate != null && element.firstCouponPaymentDate != '' && element.firstCouponPaymentDate != undefined) {
        element.firstCouponPaymentDate = { year: new Date(element.firstCouponPaymentDate).getFullYear(), month: new Date(element.firstCouponPaymentDate).getMonth() + 1, day: new Date(element.firstCouponPaymentDate).getDate() };
      } else {
        element.firstCouponPaymentDate = null;
      }
      if (element.redemptionDate != null && element.redemptionDate != '' && element.redemptionDate != undefined) {
        element.redemptionDate = { year: new Date(element.redemptionDate).getFullYear(), month: new Date(element.redemptionDate).getMonth() + 1, day: new Date(element.redemptionDate).getDate() };
      } else {
        element.redemptionDate = null;
      }
    });

    const formArrayMultiOption: FormArray = <FormArray>this.partAForm.get('multiOptionFields');
    while (formArrayMultiOption.length !== 0) {
      formArrayMultiOption.removeAt(0)
    }

    if (multiOptionDynamicFields.length > 0) {
      var count = 0;

      _.forEach(multiOptionDynamicFields, function (multiOptionFieldList) {
        const formArray: FormArray = <FormArray>self.partAForm.get('multiOptionFields');
        formArray.push(self.addDynamicMultiOptionFieldsFormGroup());
        var formGroup: FormGroup = <FormGroup>formArray.controls[count];
        formGroup.controls.couponRate.setValue(multiOptionFieldList.couponRate);
        formGroup.controls.payInDate.setValue(multiOptionFieldList.payInDate);
        formGroup.controls.firstCouponPaymentDate.setValue(multiOptionFieldList.firstCouponPaymentDate);
        formGroup.controls.redemptionDate.setValue(multiOptionFieldList.redemptionDate);
        formGroup.controls.redemptionAmountType.setValue(multiOptionFieldList.redemptionAmountType);
        if (multiOptionFieldList.isPerpetual) {
          formGroup.controls.isPerpetual.setValue('Perpetual');
        } else {
          formGroup.controls.isPerpetual.setValue('Redemption');
        }
        // formGroup.controls.isPerpetual.setValue(multiOptionFieldList.isPerpetual);
        formGroup.controls.couponType.setValue(multiOptionFieldList.couponType);
        formGroup.controls.interestPaymentFrequency.setValue(multiOptionFieldList.interestPaymentFrequency);
        formGroup.controls.faceValue.setValue(multiOptionFieldList.faceValue);

        formGroup.controls.couponRate.updateValueAndValidity()
        formGroup.controls.payInDate.updateValueAndValidity()
        formGroup.controls.firstCouponPaymentDate.updateValueAndValidity()
        formGroup.controls.redemptionDate.updateValueAndValidity()
        formGroup.controls.redemptionAmountType.updateValueAndValidity()
        formGroup.controls.isPerpetual.updateValueAndValidity()
        formGroup.controls.premiumDiscount.updateValueAndValidity()
        formGroup.controls.couponType.updateValueAndValidity()
        formGroup.controls.interestPaymentFrequency.updateValueAndValidity()
        formGroup.controls.faceValue.updateValueAndValidity()

        if (multiOptionFieldList.redemptionAmountType == 'None') {
          formGroup.controls.premiumDiscount.setValue(0);
          // $("#premiumDiscount" + count).prop("disabled", true);
        } else {
          formGroup.controls.premiumDiscount.setValue(multiOptionFieldList.premiumDiscount);
          // $("#premiumDiscount" + count).prop("disabled", false);
        }

        count++;
      })
    }
  }

  updateIssue(status, button) {
    this.disabledOnclick = true;
    // {
    if (this.partAForm.status == "VALID") {
      this.isPartATabFilled = true;
    } else {
      this.isPartATabFilled = false;
    }
    this.partAFieldsArray = [];
    this.partBFieldsArray = [];
    // Part A
    var partADynamicFields = this.partAForm.controls.partAField.value;
    for (let i = 0; i < partADynamicFields.length; i++) {
      var fieldNameA = this.partAForm.controls.partAField.value[i]['fieldName' + i];
      var defaultValueA = this.partAForm.controls.partAField.value[i]['defaultValue' + i];
      var inputTypeA = this.partAForm.controls.partAField.value[i]['inputType' + i];
      var listOfFieldsValueA = this.partAForm.controls.partAField.value[i]['listOfFieldsValue' + i];
      var partAFieldsArray = {
        FieldName: fieldNameA,
        DefaultValue: defaultValueA,
        InputType: inputTypeA,
        ListOfFieldsValue: listOfFieldsValueA,
      }
      this.partAFieldsArray.push(partAFieldsArray);
    }

    // Part B
    var partBDynamicFields = this.partBForm.controls.partBField.value;
    for (let i = 0; i < partBDynamicFields.length; i++) {
      var fieldNameB = this.partBForm.controls.partBField.value[i]['fieldName' + i];
      var defaultValueB = this.partBForm.controls.partBField.value[i]['defaultValue' + i];
      var inputTypeB = this.partBForm.controls.partBField.value[i]['inputType' + i];
      var listOfFieldsValueB = this.partBForm.controls.partBField.value[i]['listOfFieldsValue' + i];
      var partBFieldsArray = {
        FieldName: fieldNameB,
        DefaultValue: defaultValueB,
        InputType: inputTypeB,
        ListOfFieldsValue: listOfFieldsValueB,
      }
      this.partBFieldsArray.push(partBFieldsArray);
    }

    // Multiple-Options
    var multiOptionDynamicFields = this.partAForm.controls.multiOptionFields.value;
    _.forEach(multiOptionDynamicFields, function (element) {
      if (element.payInDate != null && typeof (element.payInDate) != 'object') {
        element.payInDate = { year: new Date(element.payInDate).getFullYear(), month: new Date(element.payInDate).getMonth() + 1, day: new Date(element.payInDate).getDate() };
      }
      if (element.firstCouponPaymentDate != null && typeof (element.firstCouponPaymentDate) != 'object') {
        element.firstCouponPaymentDate = { year: new Date(element.firstCouponPaymentDate).getFullYear(), month: new Date(element.firstCouponPaymentDate).getMonth() + 1, day: new Date(element.firstCouponPaymentDate).getDate() };
      }

      if (element.isPerpetual == "Perpetual") {
        element.isPerpetual = true;
        let dt = new Date('2099-12-31');
        element.redemptionDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        // console.log("element.redemptionDate", element.redemptionDate);
        // console.log("element.isPerpetual", element.isPerpetual);
      } else {
        element.isPerpetual = false;
        if (element.redemptionDate != null && typeof (element.redemptionDate) != 'object') {
          element.redemptionDate = { year: new Date(element.redemptionDate).getFullYear(), month: new Date(element.redemptionDate).getMonth() + 1, day: new Date(element.redemptionDate).getDate() };
        }
      }
    });

    var self = this;
    _.forEach(multiOptionDynamicFields, function (element) {
      if (element.payInDate != null && typeof (element.payInDate) == 'object') {
        element.payInDate = self.setDate(element.payInDate);
      }
      if (element.firstCouponPaymentDate != null && typeof (element.firstCouponPaymentDate) == 'object') {
        element.firstCouponPaymentDate = self.setDate(element.firstCouponPaymentDate);
      }
      if (element.redemptionDate != null && typeof (element.redemptionDate) == 'object') {
        element.redemptionDate = self.setDate(element.redemptionDate);
      }
    });

    var updateIssueDetails = {
      CompanyID: JSON.parse(localStorage.getItem('companyDetails')).companyID,
      issueSeries: this.partAForm.controls.issueSeries.value,
      financialYear: this.partAForm.controls.financialYear.value,
      minimumApplication: this.partAForm.controls.minApplication.value,
      minApplicationDropdown: this.partAForm.controls.minApplicationDropdown.value,
      multiples: this.partAForm.controls.multiples.value,
      multiplesDropdown: this.partAForm.controls.multiplesDropdown.value,
      issueSize: this.partAForm.controls.issueSize.value,
      calculatedRecordDate: this.partAForm.controls.calculatedRecordDate.value,
      isCashflowHolidayPreponed: this.partAForm.controls.isCashflowHolidayPreponed.value,
      optionToRetainOversubscription: this.partAForm.controls.optionToRetainOversubscription.value,
      issueOpeningDate: this.setDate(this.issueOpeningDateModel),
      issueClosingDate: this.setDate(this.issueClosingDateModel),
      "PartA": this.partAFieldsArray,
      "PartB": this.partBFieldsArray,
      "PartC": {
        maker: this.makerName,
        checker: this.selectedCheckersList,
        authoriser: this.partCForm.controls.authoriser.value,
      },
      "multiOptionForCashflow": multiOptionDynamicFields,
      issueCreatedStatus: status
    }
    this.ncdClientService.updateIssue(updateIssueDetails, this.editIssueId)
      .subscribe((issueDetail: any) => {
        if (issueDetail.status == 0) {

          if (_.size(issueDetail.data) > 0) {
            this.enableTermSheet = true
          } else {
            this.enableTermSheet = false
          }
          this.editIssueId = issueDetail.data._id;
          var self = this;
          this.issueDetails = issueDetail.data;
          if (issueDetail.data.IssueCreatedStatus == 'save' && self.issueCreated == false && button != 'update&create' && this.editTermsheetButton != true) {
            this.alert.successWithOk(issueDetail.message, 'ncdIssuesList')
          } else if (button == 'updateAfterCreate') {
            this.alert.successWithOk(issueDetail.message, 'ncd-issue/edit/' + self.editIssueId)
          } else {
            this.alert.success(issueDetail.message);
          }
        }
        else {
          this.disabledOnclick = false;
          if (issueDetail.errFields) {
            this.alert.error(JSON.stringify(issueDetail.errFields) + ' fields are required');
          } else if (issueDetail.dynamicFields) {
            this.alert.error(JSON.stringify(issueDetail.dynamicFields) + ' fields are required');
          } else {
            this.alert.error(issueDetail.message);
          }
        }
      });
  }

  // ======================================================PART A==================================================================

  getPartATermsheetData() {
    this.libraryPartAFieldsArray = [];
    this.ncdClientService.getPartATermsheetData().subscribe(partA => {
      this.libraryPartAFieldsArray = partA.data;
      var self = this;
      // removing controls
      const formArray: FormArray = <FormArray>this.partAForm.get('partAField');
      while (formArray.length !== 0) {
        formArray.removeAt(0)
      }
      if (this.libraryPartAFieldsArray && this.libraryPartAFieldsArray.length > 0) {
        var count = 0;

        _.forEach(this.libraryPartAFieldsArray, function (partAFieldList) {
          self.partADropdownList[count] = [];
          self.partAMultiSelectDropDownList[count] = [];
          const formArray: FormArray = <FormArray>self.partAForm.get('partAField');
          formArray.push(self.initialisePartAFieldsArray());
          var formGroup: FormGroup = <FormGroup>formArray.controls[count];
          self.partAFieldsValueList = partA.data[count].ListOfValues;
          for (let i = 0; i < self.partAFieldsValueList.length; i++) {
            var valueList = partA.data[count].ListOfValues[i]['newFieldValue' + i]
            self.partADropdownList[count].push(valueList);
          }

          // MultiSelect Dropdown
          if (partAFieldList.InputType == "MultiSelectDropDown") {
            self.partAMultiSelectDropDownList[count] = self.partADropdownList[count].map(function (element) {
              return {
                'label': element,
                'value': element
              }
            });
          }

          formGroup.addControl("fieldName" + count, new FormControl(partAFieldList.FieldName, []));
          formGroup.addControl("defaultValue" + count, new FormControl(partAFieldList.DefaultValue, [Validators.required]));
          formGroup.addControl("inputType" + count, new FormControl(partAFieldList.InputType, []));
          formGroup.addControl("listOfFieldsValue" + count, new FormControl(self.partAFieldsValueList, []));

          formGroup.controls["fieldName" + count].updateValueAndValidity();
          formGroup.controls["defaultValue" + count].updateValueAndValidity();

          count++;
        })
      }

    });
  }

  saveIssue(status) {
    if (this.partAForm.status == "VALID") {
      this.isPartATabFilled = true;
    } else {
      this.isPartATabFilled = false;
    }
    this.partAFieldsArray = [];
    this.partBFieldsArray = [];
    this.makerName = this.partCForm.controls.maker.value
    // Part A
    var partADynamicFields = this.partAForm.controls.partAField.value;
    for (let i = 0; i < partADynamicFields.length; i++) {
      let fieldName = this.partAForm.controls.partAField.value[i]['fieldName' + i];
      let defaultValue = this.partAForm.controls.partAField.value[i]['defaultValue' + i];
      let inputType = this.partAForm.controls.partAField.value[i]['inputType' + i];
      let listOfFieldsValue = this.partAForm.controls.partAField.value[i]['listOfFieldsValue' + i];
      var partAFieldsArray = {
        FieldName: fieldName,
        DefaultValue: defaultValue,
        InputType: inputType,
        ListOfFieldsValue: listOfFieldsValue,
      }
      this.partAFieldsArray.push(partAFieldsArray);
    }

    // Part B
    var partBDynamicFields = this.partBForm.controls.partBField.value;
    for (let i = 0; i < partBDynamicFields.length; i++) {
      let fieldName = this.partBForm.controls.partBField.value[i]['fieldName' + i];
      let defaultValue = this.partBForm.controls.partBField.value[i]['defaultValue' + i];
      let inputType = this.partBForm.controls.partBField.value[i]['inputType' + i];
      let listOfFieldsValue = this.partBForm.controls.partBField.value[i]['listOfFieldsValue' + i];
      var partBFieldsArray = {
        FieldName: fieldName,
        DefaultValue: defaultValue,
        InputType: inputType,
        ListOfFieldsValue: listOfFieldsValue,
      }
      this.partBFieldsArray.push(partBFieldsArray);
    }

    // Multiple-Options
    var multiOptionDynamicFields = this.partAForm.controls.multiOptionFields.value;
    var self = this;
    _.forEach(multiOptionDynamicFields, function (element) {
      if (element.payInDate != null || element.payInDate != '' || element.payInDate != undefined) {
        element.payInDate = self.setDate(element.payInDate);
      } else {
        element.payInDate = null;
      }
      if (element.firstCouponPaymentDate != null || element.firstCouponPaymentDate != '' || element.firstCouponPaymentDate != undefined) {
        element.firstCouponPaymentDate = self.setDate(element.firstCouponPaymentDate);
      } else {
        element.firstCouponPaymentDate = null;
      }
      if (element.redemptionDate != null || element.redemptionDate != '' || element.redemptionDate != undefined) {
        element.redemptionDate = self.setDate(element.redemptionDate);
      } else {
        element.redemptionDate = null;
      }

      if (element.isPerpetual == "Perpetual") {
        element.isPerpetual = true;
      } else {
        element.isPerpetual = false;
      }
    });


    var newPartADetails = {
      CompanyID: JSON.parse(localStorage.getItem('companyDetails')).companyID,
      issueSeries: this.partAForm.controls.issueSeries.value,
      financialYear: this.partAForm.controls.financialYear.value,
      minimumApplication: this.partAForm.controls.minApplication.value,
      minApplicationDropdown: this.partAForm.controls.minApplicationDropdown.value,
      multiples: this.partAForm.controls.multiples.value,
      multiplesDropdown: this.partAForm.controls.multiplesDropdown.value,
      issueSize: this.partAForm.controls.issueSize.value,
      calculatedRecordDate: this.partAForm.controls.calculatedRecordDate.value,
      isCashflowHolidayPreponed: this.partAForm.controls.isCashflowHolidayPreponed.value,
      optionToRetainOversubscription: this.partAForm.controls.optionToRetainOversubscription.value,
      issueOpeningDate: this.setDate(this.issueOpeningDateModel),
      issueClosingDate: this.setDate(this.issueClosingDateModel),
      "PartA": this.partAFieldsArray,
      "PartB": this.partBFieldsArray,
      "PartC": {
        maker: this.partCForm.controls.maker.value,
        checker: this.selectedCheckersList,
        authoriser: this.partCForm.controls.authoriser.value,
      },
      "multiOptionForCashflow": multiOptionDynamicFields,
      issueCreatedStatus: status
    }

    this.ncdClientService.addIssue(newPartADetails)
      .subscribe((issueDetail: any) => {
        this.disabledOnclick = false;
        if (issueDetail.status == 0) {
          this.issueDetails = issueDetail.data;
          if (_.size(this.issueDetails) > 0) {
            this.enableTermSheet = true
          } else {
            this.enableTermSheet = false
          }

          this.editIssueId = issueDetail.data._id;
          if (issueDetail.data.IssueCreatedStatus == 'save') {
            this.issueCreated = false;
            this.alert.successWithOk(issueDetail.message, 'ncdIssuesList');
          } else {
            this.alert.success(issueDetail.message);
            this.addBtn = false;
            this.issueCreated = true;
          }
        }
        else {
          if (issueDetail.errFields) {
            this.alert.error(JSON.stringify(issueDetail.errFields) + ' fields are required');
          }
          else if (issueDetail.dynamicFields) {
            this.alert.error(JSON.stringify(issueDetail.dynamicFields) + ' fields are required');
          }
          else {
            this.alert.error(issueDetail.message);
          }
        }
      });
    // }
  }

  clearPartADetails() {
    $('#clearPartAConfirmation').modal('toggle');
  }

  clearPartA() {
    this.partAForm.reset();
    this.partAForm.controls['minApplicationDropdown'].setValue("")
    this.partAForm.controls['multiplesDropdown'].setValue("")
    this.partAForm.updateValueAndValidity();
    const formArray: FormArray = <FormArray>this.partAForm.get('partAField');
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
    this.getPartATermsheetData();
  }

  // ==============================================================================================================================


  // ======================================================PART B==================================================================

  getPartBTermsheetData() {
    this.libraryPartBFieldsArray = [];
    this.ncdClientService.getPartBTermsheetData().subscribe(termsheetList => {
      this.libraryPartBFieldsArray = termsheetList.data;
      var self = this;
      // removing controls
      const formArray: FormArray = <FormArray>this.partBForm.get('partBField');
      while (formArray.length !== 0) {
        formArray.removeAt(0)
      }
      if (this.libraryPartBFieldsArray && this.libraryPartBFieldsArray.length > 0) {
        var count = 0;
        _.forEach(this.libraryPartBFieldsArray, function (partBFieldList) {
          self.partBDropdownList[count] = [];
          self.partBMultiSelectDropDownList[count] = [];
          const formArray: FormArray = <FormArray>self.partBForm.get('partBField');
          formArray.push(self.initialisePartBFieldsArray());
          var formGroup: FormGroup = <FormGroup>formArray.controls[count];
          self.partBFieldsValueList = termsheetList.data[count].ListOfValues;
          for (let i = 0; i < self.partBFieldsValueList.length; i++) {
            var valueList = termsheetList.data[count].ListOfValues[i]['newFieldValue' + i]
            self.partBDropdownList[count].push(valueList);
          }

          // MultiSelect Dropdown
          if (partBFieldList.InputType == "MultiSelectDropDown") {
            self.partBMultiSelectDropDownList[count] = self.partBDropdownList[count].map(function (element) {
              return {
                'label': element,
                'value': element
              }
            });
          }

          formGroup.addControl("fieldName" + count, new FormControl(partBFieldList.FieldName, []));
          formGroup.addControl("defaultValue" + count, new FormControl(partBFieldList.DefaultValue, [Validators.required]));
          formGroup.addControl("inputType" + count, new FormControl(partBFieldList.InputType, []));
          formGroup.addControl("listOfFieldsValue" + count, new FormControl(self.partBFieldsValueList, []));

          formGroup.controls["fieldName" + count].updateValueAndValidity();
          formGroup.controls["defaultValue" + count].updateValueAndValidity();

          count++;
        })
      }
    });
  }

  updatePartBDetails() {
    if (this.partBForm.status == "VALID") {
       
      this.partBFieldsArray = [];
      var partBDynamicFields = this.partBForm.controls.partBField.value;
      for (let i = 0; i < partBDynamicFields.length; i++) {
        var fieldName = this.partBForm.controls.partBField.value[i]['fieldName' + i];
        var defaultValue = this.partBForm.controls.partBField.value[i]['defaultValue' + i];
        var inputType = this.partBForm.controls.partBField.value[i]['inputType' + i];
        var listOfFieldsValue = this.partBForm.controls.partBField.value[i]['listOfFieldsValue' + i];
        var partBFieldsArray = {
          FieldName: fieldName,
          DefaultValue: defaultValue,
          InputType: inputType,
          ListOfFieldsValue: listOfFieldsValue,
        }
        this.partBFieldsArray.push(partBFieldsArray);
      }

      var newPartBDetails = {
        _id: this.editIssueId,
        // CompanyID: null,
        "PartB": this.partBFieldsArray
      }

      this.ncdClientService.addPartB(newPartBDetails)
        .subscribe((partB: any) => {
          if (partB.status == 0) {
            this.issueDetails = partB.data;

            if (this.restrictTabflag == false) {
              this.alert.successWithOk(partB.message, '/ncd-issue/edit/' + this.editIssueId)
            } else {
              this.alert.success(partB.message);
            }
          }
          else {
            this.alert.error(partB.message);
          }
        });
    }
  }

  clearPartBDetails() {
    $('#clearPartBConfirmation').modal('toggle');
  }

  clearPartB() {
    const formArray: FormArray = <FormArray>this.partBForm.get('partBField');
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
    this.getPartBTermsheetData();
  }

  // =================================================================================================================================

  // ========================================================PART C=========================================================================


  updatePartCDetails() {
    {
      var newPartCDetails = {
        "PartC": {
          maker: this.partCForm.controls.maker.value,
          checker: this.selectedCheckersList,
          authoriser: this.partCForm.controls.authoriser.value,
        }
      }
      this.ncdClientService.addPartC(newPartCDetails, this.editIssueId)
        .subscribe((partC: any) => {
          if (partC.status == 0) {
            this.issueDetails = partC.data;
            var self = this;
            if (self.restrictTabflag == false) {
              this.alert.successWithOk(partC.message, '/ncd-issue/edit/' + self.editIssueId)
            }
          }
          else {
            this.alert.error(partC.message);
          }
        });
    }
    // }
  }

  getCheckersList() {
    this.userList = [];
    this.taskService.getUsersList().subscribe((response) => {
      this.userList = response.result.map(function (element) {
        return {
          'label': element.FirstName + " " + element.LastName,
          'value': element._id
        }
      });
    })
  }

 

}

